import React from "react";

interface IDepartmentIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const DepartmentIcon: React.FC<IDepartmentIconProps> = ({ sizeX = 16, sizeY = 16 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" fillRule="evenodd"
                  d="M13.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-.75-1.372a2.251 2.251 0 1 0 1.5 0v-.378a3 3 0 0 0-3-3H8.75V5.372a2.25 2.25 0 1 0-1.5 0V7.25H5a3 3 0 0 0-3 3v.378a2.251 2.251 0 1 0 1.5 0v-.378A1.5 1.5 0 0 1 5 8.75h2.25v1.878a2.251 2.251 0 1 0 1.5 0V8.75H11a1.5 1.5 0 0 1 1.5 1.5zM2.75 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m4.5.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M8 2.5A.75.75 0 1 0 8 4a.75.75 0 0 0 0-1.5"
                  clipRule="evenodd"></path>
        </svg>
    );
}
